module.exports = __webpack_public_path__ + "img/file.e60e8f06.svg";